import { ANALYSIS_WIDTH } from "./thresholds";

// Decode a File/Blob, apply its EXIF rotation, and return a downscaled
// canvas for analysis plus the original size.
export const loadImage = async (blob) => {
  let source;
  try {
    source = await createImageBitmap(blob, { imageOrientation: "from-image" });
  } catch {
    source = await loadWithImgTag(blob);
  }

  const width = source.width;
  const height = source.height;
  const canvas = drawScaled(source, width, height, ANALYSIS_WIDTH);

  if (source.close) source.close();

  return { canvas, originalWidth: width, originalHeight: height };
};

const drawScaled = (source, width, height, maxWidth) => {
  const scale = Math.min(1, maxWidth / width);
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  canvas
    .getContext("2d", { willReadFrequently: true })
    .drawImage(source, 0, 0, canvas.width, canvas.height);
  return canvas;
};

const loadWithImgTag = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };
    img.src = url;
  });
